import React from 'react';
import Button from '@amzn/awsui-components-console/button';
import Box from '@amzn/awsui-components-console/box';
import SpaceBetween from '@amzn/awsui-components-console/space-between';

export interface HelpSectionProps {
	onBack: () => void;
	onPromptClick: (text: string) => void;
}

const capabilities = [
	'Check workflow status',
	'Look up task details and owners',
	'View execution details',
	'Get workflow definitions',
	'Search for workflows by entity type',
	'Document related queries',
];

const examplePrompts = [
	'What is the status of WF-123?',
	'List Workflows under Node named?',
	'Show me the execution details for EX-456',
	'List all workflows for entity type SERVER',
];

const containerStyle: React.CSSProperties = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
};

const headerStyle: React.CSSProperties = {
	padding: '16px',
	borderBottom: '1px solid #e9ebed',
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
};

const contentStyle: React.CSSProperties = {
	flex: 1,
	overflowY: 'auto',
	padding: '16px',
};

const promptButtonStyle: React.CSSProperties = {
	textAlign: 'left',
};

export const HelpSection: React.FC<HelpSectionProps> = ({ onBack, onPromptClick }) => {
	return (
		<div style={containerStyle}>
			<div style={headerStyle}>
				<Button variant="link" onClick={onBack} iconName="arrow-left">
					Back
				</Button>
				<Box variant="h3" margin={{ left: 'xs' }}>Help</Box>
			</div>
			<div style={contentStyle}>
				<SpaceBetween size="l" direction="vertical">
					<div>
						<Box variant="h4">What I can help with</Box>
						<Box variant="p" color="text-body-secondary" margin={{ top: 'xs' }}>
							Here are some things I can do:
						</Box>
						<ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
							{capabilities.map((cap) => (
								<li key={cap} style={{ marginBottom: '6px', fontSize: '14px' }}>
									{cap}
								</li>
							))}
						</ul>
					</div>
					<div>
						<Box variant="h4">Try asking</Box>
						<Box variant="p" color="text-body-secondary" margin={{ top: 'xs' }}>
							Click any example to populate the chat input:
						</Box>
						<SpaceBetween size="xs" direction="vertical">
							{examplePrompts.map((prompt) => (
								<div key={prompt} style={promptButtonStyle}>
									<Button
										variant="link"
										onClick={() => onPromptClick(prompt)}
									>
										{prompt}
									</Button>
								</div>
							))}
						</SpaceBetween>
					</div>
				</SpaceBetween>
			</div>
		</div>
	);
};
